import { InjectionToken, Provider } from '@angular/core';

import { LocalStorageService } from './local-storage.service';

export type IsVolatileValueFn = (key: string) => boolean;

export const IS_VOLATILE_VALUE_FN = new InjectionToken<IsVolatileValueFn>('IS_VOLATILE_VALUE_FN');

export const provideLocalStorageService = (isVolatileValue: IsVolatileValueFn): readonly Provider[] => [
  {
    provide: IS_VOLATILE_VALUE_FN,
    useValue: isVolatileValue,
  },
  LocalStorageService,
];

